<app-loading *ngIf="contentReady"></app-loading>

<div class="product-page" *ngIf="product">
  <section class="product-hero-card">

    <!-- LEFT: IMAGE -->
    <div class="product-media">

      @if(calcDis(product?.is_daily_offer ? product?.affiliationprice : product?.pricec, product?.priced) != 0){
      <div class="discountbadge">
        {{calcDis(product?.is_daily_offer ? product?.affiliationprice : product?.pricec, product?.priced)}}%
        {{ "discount" | transloco }}
      </div>
      }

      @if(product?.is_daily_offer){
      <div class="daily-offer-badge">
        <span class="daily-offer-label">
          {{ "saveuptotext" | transloco }}
        </span>
        <div class="chip-timer" [class.alert-error-text]="(dailyOfferState.progress$ | async)! <= 80">
          {{ dailyOfferState.timer$ | async }}
        </div>
      </div>
      }

      <div class="product-image-card">
        @if(product?.image != null){
        @if(product?.pet == '0'){
        <img class="main-product-img" [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(product?.image)"
          [errorImage]="'/assets/noproduct cat.webp'" alt="product" />
        }
        @else{
        <img class="main-product-img" [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(product?.image)"
          [errorImage]="'/assets/noproduct dog.png'" alt="product" />
        }
        }
        @else{
        @if(product?.pet == '0'){
        <img class="main-product-img" src="/assets/noproduct cat.webp" alt="product" />
        }
        @else{
        <img class="main-product-img" src="/assets/noproduct dog.png" alt="product" />
        }
        }
      </div>
    </div>

    <!-- RIGHT: SUMMARY -->
    <div class="product-summary">

      <button class="brand-link" (click)="bybrand(this.brandid)">
        {{brandname}}
      </button>

      <h1 class="product-title">
        @if(isAr){
        {{product?.name_ar}}
        }
        @else{
        {{product?.name_en}}
        }
      </h1>

      <div class="meta-badges">
        <ng-container [ngSwitch]="product?.pet">
          <span class="meta-badge" *ngSwitchCase="'0'">
            <img src="/assets/e-commerce/icons/8.webp"> {{ "cats" | transloco }}
          </span>
          <span class="meta-badge" *ngSwitchCase="'1'">
            <img src="/assets/e-commerce/icons/11.webp"> {{ "dogs" | transloco }}
          </span>
          <span class="meta-badge" *ngSwitchCase="'2'">
            <img src="/assets/e-commerce/icons/13.webp"> {{ "birds" | transloco }}
          </span>
          <span class="meta-badge" *ngSwitchCase="'4'">
            <img src="/assets/e-commerce/icons/10.webp"> {{ "cats&dogs" | transloco }}
          </span>
          <span class="meta-badge" *ngSwitchCase="'3'">
            <img src="/assets/e-commerce/icons/25.png"> {{ "other" | transloco }}
          </span>
        </ng-container>

        <ng-container [ngSwitch]="product?.category_id">
          <span class="meta-badge" *ngSwitchCase="'0'"><img src="/assets/e-commerce/icons/18.webp"> {{ "soft food" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'1'"><img src="/assets/e-commerce/icons/17.webp"> {{ "soft food can" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'2'"><img src="/assets/e-commerce/icons/23.webp"> {{ "dry food" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'3'"><img src="/assets/e-commerce/icons/31.webp"> {{ "bird food" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'4'"><img src="/assets/e-commerce/icons/29.webp"> {{ "medicine" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'5'"><img src="/assets/e-commerce/icons/27.webp"> {{ "supplement" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'6'"><img src="/assets/e-commerce/icons/26.webp"> {{ "accessories" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'7'"><img src="/assets/e-commerce/icons/24.webp"> {{ "toy" | transloco
            }}</span>
          <span class="meta-badge" *ngSwitchCase="'8'"><img src="/assets/e-commerce/icons/25.webp"> {{ "grooming" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'9'"><img src="/assets/e-commerce/icons/28.webp"> {{ "house" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'10'"><img src="/assets/e-commerce/icons/30.webp"> {{ "care" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'11'"><img src="/assets/e-commerce/icons/32.webp"> {{ "treats" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'12'"><img src="/assets/e-commerce/icons/19.webp"> {{ "training pads"
            | transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'13'"><img src="/assets/e-commerce/icons/34.webp"> {{ "bags" |
            transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'14'"><img src="/assets/e-commerce/icons/33.webp"> {{ "cleaning tools"
            | transloco }}</span>
          <span class="meta-badge" *ngSwitchCase="'15'"><img src="/assets/e-commerce/icons/20.webp"> {{ "litter" |
            transloco }}</span>
        </ng-container>
      </div>

      <div class="price-box">
        <div class="price-row">
          <span class="new-price">
            {{product?.is_daily_offer ? product?.affiliationprice : product?.pricec}} {{ "egpe" | transloco }}
          </span>

          @if(calcDis(product?.is_daily_offer ? product?.affiliationprice : product?.pricec, product?.priced) != 0){
          <span class="old-price">
            {{product?.priced}} {{ "egpe" | transloco }}
          </span>
          }
        </div>

        @if(calcDis(product?.is_daily_offer ? product?.affiliationprice : product?.pricec, product?.priced) != 0){
        <div class="save-badge">
          {{ "savedeff" | transloco }} {{ fixNumber(product?.priced - (product?.is_daily_offer ?
          product?.affiliationprice :
          product?.pricec)) }} {{ "egpe"
          | transloco }}
        </div>
        }
      </div>

      <div class="quick-highlights">
        <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <circle cx="12" cy="12" r="10" fill="#ff7a00" />
            <path d="M9 12.5l2 2 4-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg> {{ "cashpayment" | transloco }}</span>
        <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <circle cx="12" cy="12" r="10" fill="#ff7a00" />
            <path d="M9 12.5l2 2 4-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>{{ "returns" | transloco }}</span>
        <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <circle cx="12" cy="12" r="10" fill="#ff7a00" />
            <path d="M9 12.5l2 2 4-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg> {{ "cashback" | transloco }}</span>
      </div>

      <div class="short-desc">
        @if(isAr){
        {{product?.name_ar}}
        }
        @else{
        {{product?.name_en}}
        }
        <br>
        @if(isAr){
        {{product?.product_info_ar}}
        }
        @else{
        {{product?.product_info_en}}
        }
      </div>

      <div class="rating-box">
        <div class="rating-summary" *ngIf="avgRating > 0">
          <span>
            <svg class="star-svg" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </svg>
            {{ roundedRating }} / 5
          </span>
          <small>({{ ratingsCount }} {{ "rate" | transloco }})</small>
        </div>

        <div class="star-rate mt-2">
          <i *ngFor="let s of [1,2,3,4,5]" class="star" [class.active]="s <= userStars"
            (click)="tokenExists?rateProduct(s):null">
            <svg class="star-svg" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </svg>
          </i>
        </div>
      </div>

      <div class="buy-box">
        <div class="quantity-controls cartpage">
          <button (click)="min(product)" class="qty-btn">-</button>
          <span class="qty-value">{{quantity}}</span>
          <button (click)="plus(product)" class="qty-btn">+</button>
        </div>

        <button class="btn-add-main"
          [class.alert-error]="product?.is_daily_offer && (dailyOfferState.progress$ | async)! <= 80"
          (click)="plus(product);$event.stopPropagation();">
          {{ "addtocart" | transloco }}
        </button>
      </div>

    </div>
  </section>

  <!-- DESCRIPTION -->
  <section class="section-card">
    <div class="section-title">{{ "productdetails" | transloco }}</div>

    <div class="product-description">
      <div class="product-info-icons">
        <ng-container [ngSwitch]="product?.pet">
          <span *ngSwitchCase="'0'"><img src="/assets/e-commerce/icons/8.webp"> {{ "cats" | transloco }}</span>
          <span *ngSwitchCase="'1'"><img src="/assets/e-commerce/icons/11.webp"> {{ "dogs" | transloco }}</span>
          <span *ngSwitchCase="'2'"><img src="/assets/e-commerce/icons/13.webp"> {{ "birds" | transloco }}</span>
          <span *ngSwitchCase="'4'"><img src="/assets/e-commerce/icons/10.webp"> {{ "cats&dogs" | transloco }}</span>
          <span *ngSwitchCase="'3'"><img src="/assets/e-commerce/icons/25.png"> {{ "other" | transloco }}</span>
        </ng-container>
      </div>

      <p>
        @if(isAr){
        {{product?.name_ar}}
        }
        @else{
        {{product?.name_en}}
        }
        <br><br>
        @if(isAr){
        {{product?.product_info_ar}}
        }
        @else{
        {{product?.product_info_en}}
        }
      </p>
    </div>
  </section>

  <!-- BRAND INFO -->
  <section class="section-card brand-info-box">
    <div class="section-title">{{ "brand" | transloco }}</div>

    <div class="brand-info-header">
      <img class="brand-logo" [src]="brandimage" alt="brand" *ngIf="brandimage">
      <div>
        <h6 class="mb-1 text-primary">{{ brandname }}</h6>
      </div>
    </div>

    <p class="brand-description mt-3">
      {{ branddisc }}
    </p>
  </section>

  <!-- COMMENTS -->
  <section class="section-card">
    <div class="section-title">{{ "comments" | transloco }}</div>

    <div class="comment-box" *ngIf="tokenExists">
      <textarea [(ngModel)]="newComment" placeholder="{{ 'Write your opinion about the product' | transloco }}"
        class="form-control review-textarea"></textarea>

      <button class="btn btn-add-main btn-review mt-3" (click)="addComment()">
        {{ "add comments" | transloco }}
      </button>
    </div>

    <div class="comments-list mt-4" *ngIf="comments.length">
      <div class="comment-card" *ngFor="let c of comments">
        <strong>{{ c.user_name }}</strong>
        <p>{{ c.comment }}</p>
        <small>{{ c.created_at | date }}</small>
      </div>
    </div>
  </section>

  <!-- TRUST -->
  <section class="section-card">
    <div class="section-title text-primary">{{ "trustshopping" | transloco }}</div>

    <div class="trust-grid">
      <div class="trust-item">
        <img src="/assets/e-commerce/icons/40.webp">
        <span>{{ "cashpayment" | transloco }}</span>
      </div>
      <div class="trust-item">
        <img src="/assets/e-commerce/icons/41.webp">
        <span>{{ "returns" | transloco }}</span>
      </div>
      <div class="trust-item">
        <img src="/assets/e-commerce/icons/42.webp">
        <span>{{ "cashback" | transloco }}</span>
      </div>
      <div class="trust-item">
        <img src="/assets/e-commerce/icons/43.webp">
        <span>{{ "trusttrans" | transloco }}</span>
      </div>
    </div>
  </section>

  <app-productrecommendation style="padding: 0!important;"></app-productrecommendation>
</div>
